import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Handleuser(state = initialState, action) {
  switch (action.type) {
    case userConstants.HANDLEUSER_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.HANDLEUSER_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.HANDLEUSER_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}